<!-- Temporary Vue bridge for adding time entries from the timesheet panels header. -->
<!-- Prefer Zone-based dialogs for future work instead of extending this wrapper further. -->

<template lang="pug">
div
  TimeEntriesFormDialog(
    v-if="!firstLoad"
    :show="timeEntriesFormDialog.show"
    :type="timeEntriesFormDialog.type"
    :time-entry="selectedTimeEntry"
    :on-save="onSave"
    @close="close"
  )
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'TimeEntriesFormAddDialogWired',
  data() {
    return { firstLoad: true };
  },
  computed: {
    ...mapState(['timeEntriesFormDialog']),
    ...mapGetters(['selectedTimeEntry']),
  },
  mounted() {
    this.firstLoad = false;
    document.addEventListener('open-time-entry-add', this.open);
  },
  beforeDestroy() {
    document.removeEventListener('open-time-entry-add', this.open);
  },
  methods: {
    open(event = {}) {
      const timeEntry = Object.assign({}, this.$store.getters.newTimeEntry);
      const { startTime, stopTime } = event.detail || {};

      if (startTime && stopTime) {
        Object.assign(timeEntry, {
          start_time: startTime,
          stop_time: stopTime,
        });
      }

      this.$store.dispatch('openDialog', {
        dialog: 'timeEntriesFormDialog',
        type: startTime && stopTime ? 'provided' : 'add',
        timeEntry,
      });
    },
    onSave() {
      setTimeout(() => window.location.reload(), 2000);
    },
    close() {
      this.$store.dispatch('closeDialog', { dialog: 'timeEntriesFormDialog' });
    },
  },
};
</script>
